export default __webpack_public_path__ + "static/media/tara-tea.1d2e40b6.png";